<template xmlns="http://www.w3.org/1999/html">
  <div class="container">
    <div class="header">
      <h1 class="el-row">外语学能测试（视听版v1.0）<br />
        TALL (Aural Suite v1.0)</h1>
    </div>
    <div class="content">
      <div class="left"></div>
      <div class="center">
        <el-form :model="formData" ref="form" class="demo-dynamic" :rules="ruleForm">
            <div class="row">
              <el-form-item label-position="right" prop="email" label="email">
                <el-input v-model="formData.email" placeholder="Please input email"></el-input>
              </el-form-item>
            </div>
            <div class="row">
              <el-form-item label-position="right" label="invited code" prop="invitedCode">
                <el-input v-model="formData.invitedCode" placeholder="Please input invited code"></el-input>
              </el-form-item>
            </div>
            <div class="yesbutton">
              <el-button :disabled="false" type="primary" @click="submitForm">登录<br /><br />Login</el-button>
            </div>
        </el-form>
      </div>
      <div class="right"></div>
    </div>
    <div class="footer"></div>
  </div>
</template>
<script>
import GLOBAL from "../plugins/global_variable";
import request from "../plugins/request"
export default {
  name: "Emaillogin",
  data() {
    return {
      ruleForm: {
        email: [
          { required: true, message: 'Please input email', trigger: 'blur' },
          { type: 'email', message: 'Please input correct email', trigger: ['blur', 'change'] }
        ],
        invitedCode: [
          { required: true, message: 'Please input invited code', trigger: 'blur' },
          { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
        ]
      },
      invited_code: '',
      show: true,
      formData: {
        email: '',
        invitedCode: '',
      }
    };
  },
  created() {
    document.body.style.backgroundColor = "#DCDCDC";
  },

  methods: {
    async submitForm() {
      this.$refs.form.validate(valid => {
        console.log(valid)
        if (valid) {
          console.log("校验通过")
        } else {
          this.$alert(
            '表单验证失败！', 'Notice', {
            confirmButtonText: 'OK',
          });
          return false
        }
      })
      let result = await request.post("/user/auralLogin", this.formData)
      if (result.code == '200') {
        GLOBAL.invited_code = this.formData.invitedCode;
        GLOBAL.email = this.formData.email
        this.$message({
          message: '成功进入系统！',
          type: 'success',
        });
        this.$router.push('/Notification');
      } else {
        this.$alert(result.message, '提示', {
          confirmButtonText: '确定',
        })
      }
    },
  },
  mounted() {
    history.pushState(null, null, document.URL);
    window.addEventListener('popstate', function () {
      history.pushState(null, null, document.URL);
    });

  }
}
</script>

<style scoped>
.header {
  height: 100px;
  line-height: 100px;
  background-color: #D8D8D8;
  text-align: center;
  margin-bottom: 80px
}

.footer {
  height: 100px;
  line-height: 100px;
  text-align: center;
  margin-bottom: 80px
}

.el-row {
  display: flex;
  margin-bottom: 80px;
  justify-content: center
}

.yesbutton {
  display: flex;
  justify-content: center;
  margin-bottom: 80px
}

.row {
  display: flex;
  justify-content: center;
  margin-bottom: 80px
}

.container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.content {
  display: flex;
  flex-direction: row;
  flex: 1;
}

.el-row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 80px
}

.left,
.right {
  width: 400px;
}

.center {
  flex: 1;
}
</style>